module.exports = __webpack_public_path__ + "img/Certificate.65eab552.svg";